<template>
  <div class="glovo-menu-layout" :class="{ 'glovo-menu-layout--product': !!selectedProduct }">
    <product-options-panel
      v-if="selectedProduct"
      :product="selectedProduct"
      :currency="currency"
      variant="glovo"
      @close="selectedProduct = null"
    />
    <template v-else>
      <aside class="glovo-menu-layout__sidebar">
        <button
          v-for="category in categories"
          :key="category.id"
          type="button"
          class="glovo-menu-layout__nav"
          :class="{ 'is-active': category.id === activeCategoryId }"
          @click="selectCategory(category.id)"
        >
          {{ category.name }}
        </button>
      </aside>
      <div class="glovo-menu-layout__main" ref="main">
        <section
          v-for="category in categories"
          :key="'sec-' + category.id"
          :id="'glovo-cat-' + category.id"
          class="glovo-menu-layout__section"
        >
          <h2>{{ category.name }}</h2>
          <div class="glovo-menu-layout__row">
            <article
              v-for="product in category.products"
              :key="product.id"
              class="glovo-menu-layout__card"
              @click="selectedProduct = product"
            >
              <div class="glovo-menu-layout__image-wrap">
                <img v-if="product.image_url" :src="product.image_url" :alt="product.name">
                <div v-else class="glovo-menu-layout__placeholder"></div>
                <button type="button" class="glovo-menu-layout__add">+</button>
              </div>
              <h3>{{ product.name }}</h3>
              <p v-if="product.description" class="glovo-menu-layout__desc">{{ truncate(product.description) }}</p>
              <div class="glovo-menu-layout__price">{{ formatPrice(product.price) }}</div>
            </article>
          </div>
        </section>
      </div>
    </template>
  </div>
</template>

<script>
import ProductOptionsPanel from './ProductOptionsPanel.vue'

export default {
  name: 'GlovoMenuLayout',
  components: { ProductOptionsPanel },
  props: {
    categories: { type: Array, default: () => [] },
    currency: { type: String, default: 'RON' }
  },
  data () {
    return {
      activeCategoryId: null,
      selectedProduct: null
    }
  },
  watch: {
    categories: {
      immediate: true,
      handler (cats) {
        if (cats && cats.length) this.activeCategoryId = cats[0].id
        this.selectedProduct = null
      }
    }
  },
  methods: {
    selectCategory (id) {
      this.activeCategoryId = id
      this.$nextTick(() => {
        const el = document.getElementById('glovo-cat-' + id)
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' })
      })
    },
    truncate (text) {
      const s = String(text || '')
      return s.length > 90 ? s.slice(0, 87) + '...' : s
    },
    formatPrice (price) {
      const n = Number(price)
      if (Number.isNaN(n)) return ''
      return n.toFixed(2).replace('.', ',') + ' ' + this.currency
    }
  }
}
</script>

<style scoped>
.glovo-menu-layout {
  display: flex;
  height: 100%;
  min-height: 0;
  background: #fff;
}
.glovo-menu-layout__sidebar {
  width: 200px;
  flex: 0 0 200px;
  border-right: 1px solid #eee;
  padding: 12px 8px;
  overflow: auto;
}
.glovo-menu-layout__nav {
  display: block;
  width: 100%;
  text-align: left;
  border: 0;
  background: transparent;
  padding: 10px 12px;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  color: #333;
  cursor: pointer;
  border-radius: 8px;
}
.glovo-menu-layout__nav.is-active {
  background: #fff3e0;
  color: #ff6b00;
}
.glovo-menu-layout__main {
  flex: 1;
  padding: 16px 20px;
  overflow: auto;
}
.glovo-menu-layout__section h2 {
  margin: 4px 0 14px;
  font-size: 24px;
  font-weight: 800;
}
.glovo-menu-layout__row {
  display: flex;
  gap: 14px;
  overflow-x: auto;
  padding-bottom: 20px;
  margin-bottom: 18px;
}
.glovo-menu-layout__card {
  width: 170px;
  flex: 0 0 170px;
  cursor: pointer;
}
.glovo-menu-layout__image-wrap {
  position: relative;
  width: 170px;
  height: 170px;
  border-radius: 12px;
  overflow: hidden;
  background: #f5f5f5;
  margin-bottom: 8px;
}
.glovo-menu-layout__image-wrap img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.glovo-menu-layout__placeholder {
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #eee, #fafafa);
}
.glovo-menu-layout__add {
  position: absolute;
  right: 8px;
  bottom: 8px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 0;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0,0,0,.15);
  font-size: 20px;
  line-height: 1;
  cursor: pointer;
}
.glovo-menu-layout__card h3 {
  margin: 0 0 4px;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.3;
}
.glovo-menu-layout__desc {
  margin: 0 0 6px;
  color: #6b7280;
  font-size: 12px;
  line-height: 1.35;
}
.glovo-menu-layout__price {
  font-weight: 700;
  font-size: 14px;
}



.glovo-menu-layout__sidebar {
  height: 100%;
}
.glovo-menu-layout__main {
  flex: 1;
  min-height: 0;
  overflow: auto;
}
.glovo-menu-layout--product {
  display: block;
}
.glovo-menu-layout--product > * {
  height: 100%;
}

@media (max-width: 600px) {
  .glovo-menu-layout { flex-direction: column; }
  .glovo-menu-layout__sidebar { display: flex; width: 100%; height: auto; flex: 0 0 auto; overflow-x: auto; border-right: 0; border-bottom: 1px solid #eee; padding: 8px; }
  .glovo-menu-layout__nav { width: auto; flex: 0 0 auto; white-space: nowrap; }
  .glovo-menu-layout__main { min-width: 0; padding: 14px; }
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Integrations/MenuPreview/GlovoMenuLayout.vue